import { makeStyles } from '@material-ui/core/styles';

const SIDE_PADDING = 8;
const MAX_HEIGHT = 763;

export const useStyles = makeStyles(
  (theme) => ({
    wrapper: {},

    root: {},
    open: {},

    iconSubmenu: {
      fontSize: theme.typography.pxToRem(14),
      marginLeft: 'auto',
    },
    backdrop: {
      zIndex: theme.zIndex.modal - 1,
    },
    submenu: {
      // We don't want for invisible Popover div of Submenu to capture events for clicks and hovers
      // "pointer events" handling should be restored in `submenu_paper`
      pointerEvents: 'none',
    },
    submenu_paper: {
      pointerEvents: 'all',
      minWidth: 260,
      maxWidth: 480,
      maxHeight: `min(100% - ${SIDE_PADDING * 2}px, ${MAX_HEIGHT}px)`,
      marginLeft: theme.spacing(-1),
      padding: 0,
    },
    submenu_items: {},
  }),
  { name: 'InternalSubmenuListItem' }
);
